import { render } from "./Logs.vue?vue&type=template&id=12a908b2&scoped=true"
import script from "./Logs.vue?vue&type=script&lang=js"
export * from "./Logs.vue?vue&type=script&lang=js"

import "./Logs.vue?vue&type=style&index=0&id=12a908b2&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-12a908b2"

export default script